import { useQuery } from '@tanstack/react-query'
import { getPatientReservations } from 'services/reservation/getPatientReservations'

interface UseGetPatientReservations {
  quantityOfRecurrentReservations: number
  reservationProfessionalUsername: string
  isLoading: boolean
}

export const useGetPatientReservations = (patientUsername: string): UseGetPatientReservations => {
  const { data, isLoading } = useQuery({
    queryKey: ['patientReservations', patientUsername],
    queryFn: () => getPatientReservations(patientUsername),
    enabled: !!patientUsername
  })

  if (!data || isLoading) {
    return {
      quantityOfRecurrentReservations: 0,
      reservationProfessionalUsername: '',
      isLoading
    }
  }
  
  const quantityOfRecurrentReservations = data.reservations
    .filter(reservation => reservation.recurrence === 'Semanal')?.length

  const reservationProfessionalUsername = data.reservations[0].professional_username

  return {
    quantityOfRecurrentReservations,
    reservationProfessionalUsername,
    isLoading
  }
}